import { useState, useEffect } from "react";
import axios from "axios";

import { Stack, Typography, Divider } from "@mui/material";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function Main({ apex_id }) {
  const [loading, set_loading] = useState(true);
  const [error, set_error] = useState();

  const [linechart, set_linechart] = useState();

  const sx = { wrapper: { width: 1 } };

  useEffect(() => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BE_URL}/charts`,
      data: { apex_id },
    })
      .then((res) => {
        set_linechart(res.data.linechart);
      })
      .catch((err) => set_error(err.response.data))
      .finally(() => set_loading(false));
  }, [apex_id]);

  if (loading) return <Typography>loading...</Typography>;
  if (error) return <Typography>{error}</Typography>;
  return (
    <Stack sx={sx.wrapper} spacing={2}>
      <Typography>Linechart</Typography>
      <Linechart data={linechart} />
    </Stack>
  );
}

function Linechart({ data }) {
  const chart_options = {
    responsive: true,
    plugins: { legend: { position: "top" } },
  };

  const datetime_options = {
    month: "short", // 'long' for full month name
    day: "numeric",
    hour: "2-digit",
    hour12: true, // Use 12-hour clock (AM/PM)
  };

  const labels = data.labels.map((e) =>
    new Date(e).toLocaleString("en-US", datetime_options)
  );

  const datasets = [
    {
      label: "added",
      backgroundColor: COLORS.a0,
      borderColor: COLORS.a0,
      data: data.added_points,
    },
    {
      label: "removed",
      backgroundColor: COLORS.b0,
      borderColor: COLORS.b0,
      data: data.removed_points,
    },
    {
      label: "size",
      backgroundColor: COLORS.c0,
      borderColor: COLORS.c0,
      data: data.size_points,
    },
  ];

  return <Line options={chart_options} data={{ labels, datasets }} />;
}

const COLORS = {
  a0: "#e9573f",
  a1: "#fc6e51",
  b0: "#8cc152",
  b1: "#a0d468",
  c0: "#3bafda",
  c1: "#4fc1e9",
  d0: "#967adc",
  d1: "#ac92ec",
};
